import { render, staticRenderFns } from "./AgoraVideoCall.vue?vue&type=template&id=9bd5a460&scoped=true"
import script from "./AgoraVideoCall.vue?vue&type=script&lang=js"
export * from "./AgoraVideoCall.vue?vue&type=script&lang=js"
import style0 from "./AgoraVideoCall.vue?vue&type=style&index=0&id=9bd5a460&prod&lang=scss&scoped=true"
import style1 from "./AgoraVideoCall.vue?vue&type=style&index=1&id=9bd5a460&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd5a460",
  null
  
)

export default component.exports